export default __webpack_public_path__ + "static/works-4-1-e136aa88d1d85c81316072bc993de81c.jpg";